import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=e3c10c9e&"
import script from "./LoginPassword.vue?vue&type=script&lang=ts&"
export * from "./LoginPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports